import UserTaskModel from "@/models/UserTaskModel";
import UserTaskState from "@/models/UserTaskState";
import ControllerBase from "./ControllerBase";
import UserTasksEndpoints from "../endpoints/UserTasksEndpoints";
import QueryString from "qs";

export default class UserTaskController extends ControllerBase {
    /**
     * Will query legitimations by state and personId
     * @param states 
     * @param userRestricted If true will only query the states from the logged in user.
     * @returns 
     */
    list(states: UserTaskState[], userRestricted = true): Promise<UserTaskModel[]> {
        return new Promise<UserTaskModel[]>((resolve, reject) => {
            axios({
                url: UserTasksEndpoints.list.url,
                method: UserTasksEndpoints.list.method,
                params: {
                    states: states,
                    userRestricted: userRestricted
                },
                paramsSerializer: params => {
                    return QueryString.stringify(params, { arrayFormat: "repeat" })
                }
            })
                .then(response => {
                    const data = response.data as UserTaskModel[];
                    const models = data;
                    resolve(models);
                }).catch(() => reject());
        });
    }

    // /**
    //  * Will get a legitimation record by given id
    //  * @param id 
    //  * @returns 
    //  */
    // get(id: string) : Promise<LegitimationModel> {
    //     return new Promise<LegitimationModel>((resolve, reject) => {
    //         axios({
    //             url: legitimations.get.url,
    //             method: legitimations.get.method,
    //             params: {
    //                 legitimationId: id
    //             }
    //         })
    //         .then(response => {
    //             var model = new LegitimationModel(response.data as LegitimationModel);
    //             resolve(model);
    //         })
    //         .catch(() => reject());
    //     });
    // }
    // /**
    //  * Will ask for the OCR result for the ID card
    //  * @param id 
    //  * @returns 
    //  */
    // getPersonData(id: string): Promise<PersonIdCardData> {
    //     return new Promise<PersonIdCardData>((resolve, reject) => {
    //         axios({
    //             url: legitimations.getPersonData.url,
    //             method: legitimations.getPersonData.method,
    //             params: {
    //                 legitimationId: id
    //             }
    //         })
    //         .then(response => {
    //             var model = new PersonIdCardData(response.data as PersonIdCardData);
    //             resolve(model);
    //         })
    //         .catch(() => reject());
    //     });
    // }

    // updateDocument(request: UpdateLegitimationDocumentDto): Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         axios({
    //             headers: {
    //                 "content-type": "multipart/form-data"
    //             },
    //             url: legitimations.updateDocument.url,
    //             method: legitimations.updateDocument.method,
    //             data: request.getFormData()
    //         })
    //         .then(() => resolve())
    //         .catch(() => reject());
    //     });
    // }

    // confirmPersonData(request: ConfirmPersonDataDto) : Promise<void> {
    //     const clonned = cloneDeep(request);
    //     clonned.data = clonned.data.normalizeDates();
    //     return new Promise((resolve, reject) => {
    //         axios({
    //             url: legitimations.confirmPersonData.url,
    //             method: legitimations.confirmPersonData.method,
    //             data: clonned
    //         })
    //         .then(() => resolve())
    //         .catch(() => reject());
    //     });
    // }

    // confirmLegitimation(id: string) : Promise<void> {
    //     return new Promise((resolve, reject) => {
    //         axios({
    //             url: legitimations.confirmLegitimation.url,
    //             method: legitimations.confirmLegitimation.method,
    //             data: {
    //                 legitimationId: id
    //             }
    //         })
    //         .then(() => resolve())
    //         .catch(() => reject());
    //     });
    // }

    // createBlankLegitimation(): Promise<string> {
    //     return new Promise<string>((resolve, reject) => {
    //         axios({
    //             url: legitimations.createBlankLegitimation.url,
    //             method: legitimations.createBlankLegitimation.method,
    //         })
    //         .then((response) => resolve(response.data))
    //         .catch(() => reject());
    //     });
    // }

    // updateLegitimationState(legitimationId: string, state: LegitimationState): Promise<void> {
    //     return new Promise<void>((resolve, reject) => {
    //         axios({
    //             url: legitimations.updateLegitimationState.url,
    //             method: legitimations.updateLegitimationState.method,
    //             data: {
    //                 legitimationId: legitimationId,
    //                 state: state
    //             }
    //         })
    //         .then(() => resolve())
    //         .catch(() => reject());
    //     });
    // }
}